<ng-template ngFor let-tabPane [ngForOf]="tabs">
  <li class="wl-tab" [ngClass]="{ 'wl-tab-selected': tabPane.selected, 'wl-tab-invalid': !tabPane.valid }"
    *ngIf="tabPane.enabled && !tabPane.isTabWellContent" [hidden]="tabPane.hidden"
    attr.data-cy="tabComponentNavItem{{ tabPane.title | wlRegexReplace: '[\\W]+':'g':'' }}">
    <span class="wl-tab-title"
      [ngClass]="{ 'wl-tab-selected': tabPane.selected, 'wl-tab-invalid': !tabPane.valid, 'wl-tab-dirty': tabPane.dirty }"
      (click)="select(tabPane)">
      <span class="text-danger" *ngIf="!tabPane.valid">* </span>
      <span [innerHtml]="tabPane.title"></span>
    </span>
    <div [@slideReveal]="tabPane.selected || !collapseSubTabs ? 'revealed' : 'hidden'">
      <ul wlx-tab-view class="wl-vertical-tabs" [collapseSubTabs]="collapseSubTabs" [tabs]="tabPane.tabs"
        *ngIf="tabPane.tabs?.length > 0"></ul>
    </div>
  </li>
  <li class="wl-tab-well-content" *ngIf="tabPane.enabled && tabPane.isTabWellContent">
    <div wlx-tab-well-content-view [tab]="tabPane"></div>
  </li>
</ng-template>